/**
 * Composer 작성폼의 검색 제안 콜백 묶음 — 작성 성격의 web 페이지가 공유한다.
 *
 * companyId가 없으면 두 콜백 모두 undefined로 반환해 **미배선**으로 둔다. rc는 콜백이 없으면
 * 제안 없이 일반 입력으로 degrade하므로(결정 2026-08-05-composer-suggestion-source-axis),
 * 조직 컨텍스트가 없는 상태에서 인증 API를 때리는 일이 없다. 공개/외부(share·external
 * 무인증) 경로는 이 훅 자체를 쓰지 않는다.
 */
import { useMemo } from 'react';
import type { ComposerSuggestSearch, ComposerSuggestSelect } from '@safetyhub/shared';
import { createComposerSuggestSearch, createComposerSuggestSelect } from '../lib/composerSuggestions';

export interface ComposerSuggestHandlers {
  onSuggestSearch?: ComposerSuggestSearch;
  onSuggestSelect?: ComposerSuggestSelect;
}

export function useComposerSuggestHandlers(companyId: string | undefined): ComposerSuggestHandlers {
  return useMemo(() => {
    if (!companyId) return {};
    return {
      onSuggestSearch: createComposerSuggestSearch(companyId),
      onSuggestSelect: createComposerSuggestSelect(companyId),
    };
  }, [companyId]);
}
